import React, { Component } from 'react';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';
import Notifications, {notify} from 'react-notify-toast';

@inject('userStore')
class ModalAvailability extends Component {
    constructor(props){
        super(props);
        this.state = {
            event_conflict_list:null,
            artist_list:null,
            is_inquiry:false
        }
        this.checkAvailability = this.checkAvailability.bind(this);
        this.assignArtist = this.assignArtist.bind(this);
    }

    componentDidMount(){
        this.checkAvailability();
    }

    assignArtist(artist, isTrial){
        post('v2/save/assign_artist', {
                booking_id: this.props.inquiry.id,
                bus_user_id: artist.id,
                is_trial: isTrial
            }, {
                auth: {username: this.props.userStore.token}
            }).then((res) => {
              console.log(res.data);
              if (res.data.errors === 0 && res.data.type === 'unassign'){
                  artist.is_assigned = false;
                  notify.show(res.data.message, "success", 1000);

              } else if (res.data.errors === 0 && res.data.type === 'assign') {
                  artist.is_assigned = true;
                  artist.is_trial = isTrial;
                  notify.show(res.data.message, "success", 1000);
              }
              let temp_artist_list = Object.assign([], this.state.artist_list);
              let index = this.state.artist_list.findIndex(x => x.id === artist.id);
              temp_artist_list[index] = artist;
              this.setState({artist_list:temp_artist_list});
              if (res.data.errors !== 0){
                  notify.show(res.data.message, "danger", 1000);
              }
          }).catch((error) => {
                console.log(error);
                return error;
          });
    }

    checkAvailability(){
      let data = null
      if (this.props.inquiry){
        data = {bk_temp_hash_id: this.props.inquiry.hash_id}
      } else if (this.props.date) {
        data = {event_date:this.props.date.toISOString().slice(0,10), business_id:this.props.business_id}
      }
      if (data){
        post('v2/get/conflicts', {
              data
            }, {
              auth: {username: this.props.userStore.token}
            }).then((res) => {
              this.setState({
                  event_conflict_list:res.data.event_conflict_list,
                  artist_list:res.data.artist_list,
                  is_inquiry:res.data.is_inquiry
              })
          }).catch((error) => {
                console.log(error);
                return error;
          });
      }
    }

  render() {
    if (!this.props.date && !this.props.inquiry){
      return <div className="alert alert-danger">Could not load availbility.</div>;
    }
    const CheckBox = props => {
      const checked = props.assigned === true ? "checked" : null;
      return <input {...props} checked={checked}/>
    };
    return (
    	<React.Fragment>
            <Notifications />
            {this.state.is_inquiry ?
            <div className="card card-bordered">
                <h4 className="card-title">Event Conflicts</h4>
                <div className="media-list media-list-divided">
                {this.state.event_conflict_list ? this.state.event_conflict_list.length === 0 ? <div className="media media-single"><span className="badge badge-success">No conflicts</span></div> : this.state.event_conflict_list.map((conflict, conflict_index)=>{
                    return (
                        <div key={conflict_index} className="media media-single">
                            <i className="fa fa-exclamation-circle text-danger fs-30"></i>
                            <span className="lead">{conflict.event_name}</span>
                            <span className="divider-dash">Ready Time: {conflict.ready_time}</span>
                        </div>
                    );
                }) : <span className="text media media-single">Loading Please Wait...</span>}
                </div>
            </div>:
            null
            }
            <div className="card card-bordered">
                <h4 className="card-title">Artists & Availability</h4>
                <div className="media-list media-list-divided">
                {this.state.artist_list ? this.state.artist_list.map((artist, index) => {
                    return (
                        <div key={index} className="media media-single">
                            <img className="avatar avatar-sm" src={artist.avatar} alt="..."/>
                            <div className="media-body">
                                <span>{artist.full_name}</span><br/>
                                {!this.state.is_inquiry ?
                                    <React.Fragment>
                                    <div className="btn-group">
                                        {artist.is_assigned ? <button className="btn btn-xs btn-info" onClick={() => this.assignArtist(artist, false)}>Unassign{artist.is_trial ? <span> - Lead Artist</span> : null }</button> : <React.Fragment><button className="btn btn-xs btn-primary" onClick={() => this.assignArtist(artist, false)}>Assign</button><button className="btn btn-xs btn-primary" onClick={() => this.assignArtist(artist, true)}>Assign as Lead</button></React.Fragment>}
                                    </div>
                                    </React.Fragment>
                                :null
                                }
                            </div>
                            <div>
                                <ul className="list-unstyled">
                                {artist.conflicts.bk_list.length === 0 && artist.conflicts.to_list.length === 0 ? <li><span className="badge badge-success">No Conflicts</span></li> : null}
                                {artist.conflicts.bk_list.length > 0 ? artist.conflicts.bk_list.map((conflict, index)=><li key={index}><span className="badge badge-danger">{conflict.title}</span></li>) : null}
                                {artist.conflicts.to_list.length > 0 ? artist.conflicts.to_list.map((conflict, index)=><li key={index}><span className="badge badge-danger">{conflict.title}</span></li>) : null}
                                </ul>
                            </div>
                        </div>
                    );
                }) :  <span className="text media media-single">Loading Please Wait...</span>}
                </div>
            </div>
        </React.Fragment>
    )
  }
}

export default ModalAvailability;

// if (!this.props.inquiry){
//   return <div className="alert alert-danger">{this.state.is_inquiry ? <React.Fragment>No Inquiry Loaded</React.Fragment> : <React.Fragment>No Booking Loaded</React.Fragment>}</div>
// } else if (!this.props.date) {
//
// }
// this.props.event_date



// WEBPACK FOOTER //
// ./src/components/business/ModalAvailability.js